import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCkI1UMhtaBHl6iGtUtVi8bJSBgnujDYns",
  authDomain: "gcp-virtual-production-lab.firebaseapp.com",
  projectId: "gcp-virtual-production-lab",
  storageBucket: "gcp-virtual-production-lab.firebasestorage.app",
  messagingSenderId: "341316871807",
  appId: "1:341316871807:web:38e6a5d2bec25a224e414a",
  measurementId: "G-FST9YHN2EW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

export default app;

